// @ts-nocheck
import action from 'utils/actionCreators';

export const FORECAST_SHOW_LOADER = 'FORECAST_SHOW_LOADER';

export const GET_FORECAST_DATA_REQUEST = 'GET_FORECAST_DATA_REQUEST';
export const GET_FORECAST_DATA_SUCCESS = 'GET_FORECAST_DATA_SUCCESS';
export const GET_FORECAST_DATA_FAILURE = 'GET_FORECAST_DATA_FAILURE';

export const UPDATE_FORECAST_CELL_DATA = 'UPDATE_FORECAST_CELL_DATA';

export const POST_FORECAST_DATA_REQUEST = 'POST_FORECAST_DATA_REQUEST';
export const POST_FORECAST_DATA_SUCCESS = 'POST_FORECAST_DATA_SUCCESS';
export const POST_FORECAST_DATA_FAILURE = 'POST_FORECAST_DATA_FAILURE';

export const GET_FORECAST_ROW_DATA_REQUEST = 'GET_FORECAST_ROW_DATA_REQUEST';
export const GET_FORECAST_ROW_DATA_SUCCESS = 'GET_FORECAST_ROW_DATA_SUCCESS';
export const GET_FORECAST_ROW_DATA_FAILURE = 'GET_FORECAST_ROW_DATA_FAILURE';

export const DELETE_FORECAST_DATA_REQUEST = 'DELETE_FORECAST_DATA_REQUEST';
export const DELETE_FORECAST_DATA_SUCCESS = 'DELETE_FORECAST_DATA_SUCCESS';
export const DELETE_FORECAST_DATA_FAILURE = 'DELETE_FORECAST_DATA_FAILURE';

export const UPDATE_CLAIM_DATA = 'UPDATE_CLAIM_DATA';

export const POST_CLAIM_DATA_REQUEST = 'POST_CLAIM_DATA_REQUEST';
export const POST_CLAIM_DATA_SUCCESS = 'POST_CLAIM_DATA_SUCCESS';
export const POST_CLAIM_DATA_FAILURE = 'POST_CLAIM_DATA_FAILURE';

export const GET_CLAIM_ROW_DATA_REQUEST = 'GET_CLAIM_ROW_DATA_REQUEST';
export const GET_CLAIM_ROW_DATA_SUCCESS = 'GET_CLAIM_ROW_DATA_SUCCESS';
export const GET_CLAIM_ROW_DATA_FAILURE = 'GET_CLAIM_ROW_DATA_FAILURE';

export const CLEAR_UPDATED_FORECAST_DATA_MSG =
  'CLEAR_UPDATED_FORECAST_DATA_MSG';

export const FILTER_COLUMNS = 'FILTER_COLUMNS';

export const COLLAPSE_COLUMN = 'COLLAPSE_COLUMN';

export const FILTER_MONTHS = 'FILTER_MONTHS';

export const GET_FILTERED_FORECAST_DATA_REQUEST =
  'GET_FILTERED_FORECAST_DATA_REQUEST';
export const GET_FILTERED_FORECAST_DATA_SUCCESS =
  'GET_FILTERED_FORECAST_DATA_SUCCESS';
export const GET_FILTERED_FORECAST_DATA_FAILURE =
  'GET_FILTERED_FORECAST_DATA_FAILURE';

export const SEARCH_FORECAST_DATA = 'SEARCH_FORECAST_DATA';

export const UPDATE_SUB_TASK_PERCENTAGE = 'FORECAST/UPDATE_SUB_TASK_PERCENTAGE';

export const getForecastDataRequest = action(
  GET_FORECAST_DATA_REQUEST,
  'params',
);
export const getForecastDataSuccess = action(GET_FORECAST_DATA_SUCCESS);
export const getForecastDataFailure = action(GET_FORECAST_DATA_FAILURE);

export const getFilteredForecastDataRequest = action(
  GET_FILTERED_FORECAST_DATA_REQUEST,
  'params',
);

export const updateForecastCellData = action(
  UPDATE_FORECAST_CELL_DATA,
  'payload',
);

export const postForecastDataRequest = action(
  POST_FORECAST_DATA_REQUEST,
  'payload',
);

export const getForecastRowDataRequest = action(
  GET_FORECAST_ROW_DATA_REQUEST,
  'payload',
);

export const deleteForecastDataRequest = action(
  DELETE_FORECAST_DATA_REQUEST,
  'payload',
);

export const updateClaimData = action(UPDATE_CLAIM_DATA, 'payload');

export const postClaimDataRequest = action(POST_CLAIM_DATA_REQUEST, 'payload');

export const getClaimRowDataRequest = action(
  GET_CLAIM_ROW_DATA_REQUEST,
  'payload',
);

export const searchForecastData = action(SEARCH_FORECAST_DATA, 'payload');

export const EXPAND_SECTION = 'EXPAND_SECTION';

export const expandSection = action(EXPAND_SECTION, 'payload');

export const FILTER_SECTION = 'FILTER_SECTION';

export const filterSection = action(FILTER_SECTION, 'payload');

export const FILTER_COLUMN = 'FILTER_COLUMN';

export const filterColumn = action(FILTER_COLUMN, 'payload');

export const SELECT_ROW_FOR_DELETION = 'SELECT_ROW_FOR_DELETION';

export const selectRowForDeletion = action(SELECT_ROW_FOR_DELETION, 'payload');

export const RESET_SELECTED_ROW_FOR_DELETION =
  'RESET_SELECTED_ROW_FOR_DELETION';

export const resetSelectedRowForDeletion = action(
  RESET_SELECTED_ROW_FOR_DELETION,
);

export const EXPAND_ROW = 'EXPAND_ROW';
export const EXPAND_ALL_ROW = 'EXPAND_ALL_ROW';
export const COLLAPSE_ALL_ROW = 'COLLAPSE_ALL_ROW';

export const expandRow = action(EXPAND_ROW, 'payload');
export const expandAllRow = action(EXPAND_ALL_ROW, 'payload');
export const collapseAllRow = action(COLLAPSE_ALL_ROW);

export const RESET_FORECAST_STATE = 'RESET_FORECAST_STATE';

export const resetForecastState = action(RESET_FORECAST_STATE);

export const updateSubTaskPercentage = action(
  UPDATE_SUB_TASK_PERCENTAGE,
  'payload',
);
